export default __webpack_public_path__ + "static/media/img-4.9be18a42.jpg";